import React from 'react';
import { motion } from 'framer-motion';
import { useOnboardingStore } from '@/hooks/use-onboarding-store';

interface Step3ExperienceProps {
  onNext: () => void;
}

const Step3Experience: React.FC<Step3ExperienceProps> = ({ onNext }) => {
  const { setAnswer } = useOnboardingStore();

  const options = [
    { value: 'beginner', label: '👶 Complete Beginner (No prior coding/dev experience)' },
    { value: 'basic', label: '📚 Basic Knowledge (Tried some coding/tutorials)' },
    { value: 'intermediate', label: '🛠️ Intermediate (Built small projects/websites)' },
    { value: 'experienced', label: '👨‍💻 Experienced Developer (Looking to integrate AI)' },
    { value: 'entrepreneur', label: '💼 Entrepreneur/Business Owner (Focus on ideas, not code)' },
  ];

  const handleSelect = (value: string) => {
    setAnswer('experience', value);
    setTimeout(onNext, 300);
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="p-6 max-w-lg mx-auto"
    >
      <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">
        What's your current experience level?
      </h2>
      <p className="text-gray-600 text-center mb-8">
        Help us tailor the course to your background
      </p>

      <div className="space-y-4">
        {options.map((option, index) => (
          <motion.button
            key={option.value}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            onClick={() => handleSelect(option.value)}
            className="w-full p-4 text-left bg-white border-2 border-gray-200 rounded-xl hover:border-nocode-blue hover:bg-blue-50 transition-all duration-300 group"
          >
            <span className="text-lg group-hover:scale-110 transition-transform duration-300 inline-block mr-3">
              {option.label.split(' ')[0]}
            </span>
            <span className="text-gray-700 group-hover:text-nocode-blue font-medium">
              {option.label.substring(option.label.indexOf(' ') + 1)}
            </span>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default Step3Experience;